module.exports = __webpack_public_path__ + "img/treko.ff28c927.webp";